module.exports = __webpack_public_path__ + "static/media/TGK_110.b611bffa.png";